import * as z from 'zod';

import { TranslationFunctionType } from '@/shared/globalTypes';

export const createTgBotFormDataSchema = (t: TranslationFunctionType) =>
  z.object({
    token: z.string().min(1, t('common:errors.required')),
  });

export const createVkFormDataSchema = (t: TranslationFunctionType) =>
  z.object({
    token: z.string().min(1, t('common:errors.required')),
    groupId: z.string().min(1, t('common:errors.required')),
  });

export const avitoConnectFormDataSchema = (t: TranslationFunctionType) =>
  z.object({
    clientId: z.string().min(1, t('common:errors.required')),
    clientSecret: z.string().min(1, t('common:errors.required')),
    name: z.string().optional(),
  });

export const wildberriesConnectFormDataSchema = (t: TranslationFunctionType) =>
  z.object({
    token: z.string().min(1, t('common:errors.required')),
    name: z.string().optional(),
  });

export const ozonConnectFormDataSchema = (t: TranslationFunctionType) =>
  z.object({
    clientId: z.string().min(1, t('common:errors.required')),
    apiKey: z.string().min(1, t('common:errors.required')),
    name: z.string().optional(),
  });

export const enterPasswordTgPersonalFormDataSchema = (
  t: TranslationFunctionType
) =>
  z.object({
    password: z.string().min(1, t('common:errors.required')),
  });

export const selectCompanySchemaFormData = z.object({
  companyId: z.string(),
});

export const changeChannelNameFormDataSchema = (t: TranslationFunctionType) =>
  z.object({
    name: z
      .string()
      .min(1, t('channels:settings.inputs.channelName.errors.min'))
      .max(55, t('channels:settings.inputs.channelName.errors.max'))
      .regex(
        /^[а-яА-ЯёЁa-zA-Z0-9\s-_]+$/,
        t('channels:settings.inputs.channelName.errors.pattern')
      )
      .refine((value) => value.trim().length > 0, {
        message: t('channels:settings.inputs.channelName.errors.min'),
      }),
  });

export const changePhoneNumberFormDataSchema = z.object({
  phoneNumber: z.string(),
});

export const telegramPersonalPhoneFormDataSchema = (
  t: TranslationFunctionType
) =>
  z.object({
    phone: z.string().min(1, t('common:errors.required')),
  });

export const telegramPersonalVerifyCodeDataSchema = (
  t: (key: string) => string,
  length = 5
) =>
  z.object({
    code: z.string().regex(new RegExp(`^\\d{${length}}$`), t('channels:codeVerification.invalidCode')),
  });
